import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/style.css'

createApp(App).mount('#app')
